export { default as Logo } from "../assets/images/app-images/logo.png";

// ````````````````````````` NAV BAR ICONS `````````````````````````
export { default as profile } from "../assets/images/app-images/profile.png";
export { default as NavIconTwo } from "../assets/svgs/hand-shake-icon.svg";
export { default as NavIconOne } from "../assets/svgs/hand-shake-icon.svg";
export { default as NavIconThree } from "../assets/svgs/Boxes_light.svg";
export { default as NavIconFour } from "../assets/svgs/hammer-icon.svg";
export { default as NavIconFive } from "../assets/svgs/express-delivery-icon.svg";
export { default as NavIconSix } from "../assets/svgs/Paper_light.svg";
export { default as NavIconSeven } from "../assets/svgs/dollar.svg";
export { default as NavIconEight } from "../assets/svgs/Setting_line.svg";
export { default as NavIconNine } from "../assets/svgs/consignment.svg";
export { default as NavIconTen } from "../assets/svgs/Message_light.svg";
export { default as dummyImage } from "../assets/images/app-images/homebg.png";
export { default as LogoutIcon } from "../assets/svgs/logout-icon.svg";

// ````````````````````````` NAV BAR ICONS `````````````````````````
